import { useTranslation } from "react-i18next";
const QuestionTextInput = (props) => {
    const { t } = useTranslation()
    return (
        <div class="mb-3">
            <label for="questionText" class="form-label"><b>{t("questionText")}</b></label><br /><i></i>
            <textarea class="form-control" id="questionText" />
        </div>
    );
};

export default QuestionTextInput;